import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import Play from '../../icons/Play';
import Pause from '../../icons/Pause';

import audioStyle from './audio.module.css';

const getFormatTime = (time) => {
  if (!time) return '0:00';

  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time - minutes * 60);

  return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
}

const Audio = (props) => {
  const audio = useRef(null);

  const [play, setPlay] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);

  const handlePlayClick = () => {
    setPlay(true);
    audio.current.play();
  }

  const handlePauseClick = () => {
    setPlay(false);
    audio.current.pause();
  }

  const handleTimeUpdate = (e) => {
    const progress =  e.target.currentTime / props.duration * 100 + '%';
    document.documentElement.style.setProperty('--progress', progress);
    setCurrentTime(e.target.currentTime);
  }

  const handleEnded = () => {
    audio.current.pause();
    setPlay(false);
    setCurrentTime(0);
    document.documentElement.style.setProperty('--progress', 0);
  }

  const handleInput = (e) => {
    const progress =  e.target.value / props.duration * 100 + '%';
    document.documentElement.style.setProperty('--progress', progress);
    audio.current.currentTime = e.target.value;
    setCurrentTime(e.target.value);
  }

  const handleChange = (e) => {
    const progress =  e.target.value / props.duration * 100 + '%';
    document.documentElement.style.setProperty('--progress', progress);
    audio.current.currentTime = e.target.value;
    setCurrentTime(e.target.value);
  }

  useEffect(() => {
    return  () => document.documentElement.style.setProperty('--progress', 0);
  }, [props.src]);

  return (
    <React.Fragment>
      <audio
        src={props.src}
        controls
        ref={audio}
        className={audioStyle.hiddenAudio}
        onTimeUpdate={handleTimeUpdate}
        onEnded={handleEnded}
      />

      <input
        type="range"
        min="0"
        max={props.duration}
        step="0.01"
        value={currentTime}
        onInput={handleInput}
        onChange={handleChange}
        className={audioStyle.inputRange}
      />

      <div className={audioStyle.player}>
        <div className={audioStyle.playerBody}>
          {play ? (
            <button type="button" className={audioStyle.playButton} onClick={handlePauseClick}>
              <Pause />
            </button>
          ) : (
            <button type="button" className={audioStyle.playButton} onClick={handlePlayClick}>
              <Play />
            </button>
          )}

          <div>{props.title}</div>

          <time className={audioStyle.duration}>
            <span className={audioStyle.pink}>{getFormatTime(currentTime)}</span> / {getFormatTime(props.duration)}
          </time>
        </div>
      </div>
    </React.Fragment>
  );
}

Audio.propTypes = {
  src: PropTypes.string,
  title: PropTypes.string,
  duration: PropTypes.number,
}

Audio.defaultProps = {
  src: '',
  title: '',
  duration: 0,
}

export default Audio;
